module.exports = __WEBPACK_EXTERNAL_MODULE_53__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","getMonth"],"commonjs":"date-fns/get_month/index","commonjs2":"date-fns/get_month/index"}
// module id = 53
// module chunks = 0